import { Component, OnInit } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { addSelectedFilter, loadStockRequest, removeAllFilters, removeSelectedFilter, setResultsCount, setSelectedFilters } from 'src/app/actions';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';
import { Filter, FilterComparisonOperator, FilterGroupLogicaOperator, FilterKey, FilterLogicaOperator, FilterType, Stock } from 'src/app/models';
import { filtersSelector, selectedFiltersSelector, stockSelector } from 'src/app/selectors';
import { ModuleState } from 'src/app/state';

@Component({
  templateUrl: './search-filters-bar.container.html',
  selector: 'search-filters-bar'
})
export class SearchFiltersBarContainer implements OnInit {

  constructor(
    private store: Store
    ) { }

  filters = [];
  selectedFilters = [];
  language: Language;
  resultsCount: number = 0;

  removeAllFilters(): void {
    this.store.dispatch(removeAllFilters())
  }

  selectFilter(filter: Filter) {
    return this.store.dispatch(addSelectedFilter({ filter }));
  }

  addBloqueFilter(bloque: Stock['BLOQUE']): void {
    this.store.dispatch(removeSelectedFilter({ filter: <Filter>{ key: FilterKey.BLOQUE, type: FilterType.UNIQUE } }))
    return this.store.dispatch(addSelectedFilter({ filter: {
      type: FilterType.UNIQUE,
      comparator: FilterComparisonOperator.EQUAL,
      logicalOperator: FilterLogicaOperator.AND,
      groupLogicalOperator: FilterGroupLogicaOperator.OR,
      value: bloque,
      key: FilterKey.BLOQUE,
      name: bloque
    }}))
  }

  removeFilter(filter: Filter) {
    if(filter.type === FilterType.RANGE) {+
      this.store.dispatch(removeSelectedFilter({ filter: {
        ...filter,
        comparator: FilterComparisonOperator.GREATER_OR_EQUAL_THAN
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: {
        ...filter,
        comparator: FilterComparisonOperator.LESS_OR_EQUAL_THAN
      }}))
    } else {
      this.store.dispatch(removeSelectedFilter({ filter }))
    }
  }

  ngOnInit() {
    this.store.select(filtersSelector).subscribe(filters => {
      this.filters = filters
    })

    this.store.select((state: ModuleState) => state.resultsCount).subscribe(count => this.resultsCount = count);

    this.language = getLanguage(getLanguageFromUrl());



    this.store.select(selectedFiltersSelector).subscribe(filters => {
      //console.log(filters)
      this.selectedFilters = filters;
    })
  }

}
